import { LocalizedLink } from '@/components/LocalizedLink';
import { ChevronRight } from 'lucide-react';
import { useT } from '@/lib/i18n';

interface LandingPageBreadcrumbProps {
  current: string;
}

export function LandingPageBreadcrumb({ current }: LandingPageBreadcrumbProps) {
  const t = useT();
  return (
    <nav
      aria-label={t('Breadcrumb', 'Breadcrumb')}
      className="border-b border-border/40 bg-background/60 py-3"
    >
      <div className="container mx-auto px-4">
        <ol className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
          <li>
            <LocalizedLink to="/" className="hover:text-foreground transition-colors">
              {t('Startseite', 'Home')}
            </LocalizedLink>
          </li>
          <li aria-hidden="true">
            <ChevronRight className="h-3 w-3" />
          </li>
          <li>
            <LocalizedLink to="/consulting" className="hover:text-foreground transition-colors">
              Consulting
            </LocalizedLink>
          </li>
          <li aria-hidden="true">
            <ChevronRight className="h-3 w-3" />
          </li>
          <li aria-current="page" className="font-medium text-foreground">
            {current}
          </li>
        </ol>
      </div>
    </nav>
  );
}